const addApiErrorMessages = (messages, value) => {
    if (!value) {
        return;
    }

    if (Array.isArray(value)) {
        value.forEach((item) => addApiErrorMessages(messages, item));
        return;
    }

    if (typeof value === "string") {
        value
            .split("\n")
            .map((message) => message.trim())
            .filter(Boolean)
            .forEach((message) => messages.push(message));
        return;
    }

    if (typeof value === "object") {
        if (value.message) {
            addApiErrorMessages(messages, value.message);
            return;
        }

        Object.values(value).forEach((item) => addApiErrorMessages(messages, item));
    }
};

export const getApiErrorMessages = (error, fallbackMessage = "Unexpected Error") => {
    const messages = [];
    const data = error?.data ?? error?.response?.data ?? null;

    if (typeof data === "string") {
        addApiErrorMessages(messages, data);
    } else {
        addApiErrorMessages(messages, data?.errorDetails);
        addApiErrorMessages(messages, data?.errors);
        addApiErrorMessages(messages, data?.domainErrors);
        addApiErrorMessages(messages, data?.detail);
        addApiErrorMessages(messages, data?.message);
        addApiErrorMessages(messages, data?.error);
    }

    if (messages.length === 0) {
        addApiErrorMessages(messages, data?.title);
    }

    if (messages.length === 0) {
        addApiErrorMessages(messages, error?.message);
    }

    if (messages.length === 0) {
        addApiErrorMessages(messages, fallbackMessage);
    }

    return [...new Set(messages)];
};

export const toApiError = (error) => {
    if (error?.status !== undefined && error?.message !== undefined && Object.prototype.hasOwnProperty.call(error, "data")) {
        return error;
    }

    const status = error?.response?.status ?? 0;
    const data = error?.response?.data ?? null;
    const [message] = getApiErrorMessages(error);

    return {
        status,
        message,
        data,
        config: error?.config
    };
};
